module.exports = __webpack_public_path__ + "img/moutmir.79224992.png";